export default function create(options) {
  const {
    angle = 20,
    direction = 'counter-clockwise'
  } = options.namedEffect;
  return [{
    ...options,
    part: 'BG_MEDIA',
    startOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 0
      }
    },
    endOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 100
      }
    },
    keyframes: [{
      transform: `skewY(${direction === 'counter-clockwise' ? angle : -angle}deg)`
    }, {
      transform: `skewY(${direction === 'counter-clockwise' ? -angle : angle}deg)`
    }]
  }];
}
//# sourceMappingURL=BgSkew.js.map